import type { ActiveSchedules, Line4ScheduleId, Line6ScheduleId, ScheduleSelection } from "../domain/schedule-selection.ts";

export interface ScheduleControls {
  update(selection: ScheduleSelection, schedules: ActiveSchedules): void;
  destroy(): void;
}

export function mountScheduleControls(
  container: HTMLElement,
  initialSelection: ScheduleSelection,
  onChange: (selection: ScheduleSelection) => void,
): ScheduleControls {
  container.innerHTML = `
    <section class="schedule-picker" aria-label="运行图选择">
      <label class="schedule-auto"><input type="checkbox" data-schedule-auto>自动切换</label>
      <label class="schedule-line"><span>4号线列车运行图</span><select data-line4-schedule aria-label="4号线列车运行图"><option>T0402</option><option>T0403</option><option>T0404</option><option>T0405</option></select></label>
      <label class="schedule-line"><span>6号线列车运行图</span><select data-line6-schedule aria-label="6号线列车运行图"><option>G0601</option><option>G0602</option><option>S0601</option><option>S0602</option><option>T0601</option></select></label>
    </section>
    <section class="schedule-current" aria-live="polite">
      <span>当前生效</span>
      <strong data-schedule-current>正在加载…</strong>
      <small data-schedule-rule></small>
    </section>`;

  const automatic = container.querySelector<HTMLInputElement>("[data-schedule-auto]")!;
  const line4 = container.querySelector<HTMLSelectElement>("[data-line4-schedule]")!;
  const line6 = container.querySelector<HTMLSelectElement>("[data-line6-schedule]")!;
  const current = container.querySelector<HTMLElement>("[data-schedule-current]")!;
  const rule = container.querySelector<HTMLElement>("[data-schedule-rule]")!;
  let active: ActiveSchedules = { generation: "legacy", line4: "T0402", line6: "G0601", calendar: "weekday" };
  const handleAutomaticChange = (): void => onChange(automatic.checked ? "auto" : { mode: "manual", line4: active.line4, line6: active.line6 });
  const handleScheduleChange = (): void => onChange({ mode: "manual", line4: line4.value as Line4ScheduleId, line6: line6.value as Line6ScheduleId });
  automatic.addEventListener("change", handleAutomaticChange);
  line4.addEventListener("change", handleScheduleChange);
  line6.addEventListener("change", handleScheduleChange);

  const update = (selection: ScheduleSelection, schedules: ActiveSchedules): void => {
    active = schedules;
    automatic.checked = selection === "auto";
    line4.value = typeof selection === "object" ? selection.line4 : schedules.line4;
    line6.value = typeof selection === "object" ? selection.line6 : schedules.line6;
    current.textContent = `4号线 ${schedules.line4} · 6号线 ${schedules.line6}`;
    const dateRule = schedules.calendar === "weekend" ? "双休日" : "工作日";
    rule.textContent = `${automatic.checked ? "自动切换" : "手动选择"} · ${dateRule}`;
  };
  update(initialSelection, active);

  return {
    update,
    destroy: () => {
      automatic.removeEventListener("change", handleAutomaticChange);
      line4.removeEventListener("change", handleScheduleChange);
      line6.removeEventListener("change", handleScheduleChange);
    },
  };
}
